import * as S from "./InquiryContactList.style";
import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";

interface InquiryPrivateListProps {
  children?: React.ReactNode;
}

export const InquiryContactList = ({ children }: InquiryPrivateListProps) => {
  const navigate = useNavigate();
  return (
    <S.InquiryContactList>
      <S.ListTit>
        나의 문의 내역
        <Buttons
          type="button"
          size="sm"
          width="100px"
          layout="outline"
          color="primary100"
          label="1:1 문의하기"
          onClick={() => navigate("/setting/inquiry/contacts/write")}
        />
      </S.ListTit>
      <S.ListContent>{children}</S.ListContent>
    </S.InquiryContactList>
  );
};
